import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 1
export const listName = 'financeiro.categorias.lista'
export const listStorage = tableColumnsCache(listName, [
    {label: 'ID', name: 'id', active: false, sortable: true, ordering: 1},
    {label: 'Status', name: 'status', active: true, sortable: true, ordering: 1},
], listVersion)
